"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const i18n = require("@ms/yammer-i18n");
const safeStrs={failedToLoadCallToAction:1,inboxThreadErrorCannotRender:1,thirdPartyCookiesDisabledSecondLine:1,thirdPartyCookiesBlockedPageMessage:1};
exports.default = i18n.getStringInterpolator(safeStrs, 'error');
